import { render, staticRenderFns } from "./Campaigns.html?vue&type=template&id=b01b9b60&external"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"
import style0 from "./Campaigns.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports